import {
  Component,
  Inject,
  forwardRef,
  NgModule,
  ViewEncapsulation
} from '@angular/core';
import { OLightTableComponent } from './o-light-table.component';
import { OSharedModule } from 'ontimize-web-ngx';
import { CommonModule } from '@angular/common';


export class OLightTableButtonPanelComponent {
  public table: OLightTableComponent;
  constructor(  table: OLightTableComponent) {
    this.table = table;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-light-table-button-panel',
  template: `
    <md-toolbar class="o-light-table-button-panel">
      <div class="mat-toolbar-tools" *ngIf="!table.deleting">
        <span fxFlex></span>
        <button type="button" md-icon-button (click)="table.filter($event)">
          <md-icon aria-label="Filter items">filter_list</md-icon>
        </button>
        <button type="button" id="removeButton" md-icon-button (click)="table.remove($event)">
          <md-icon aria-label="Select items to delete">delete</md-icon>
        </button>
        <button type="button" md-icon-button (click)="table.add($event)" >
          <md-icon aria-label="New item">add</md-icon>
        </button>
      </div>

      <div class="mat-toolbar-tools" *ngIf="table.deleting">
        <button  type="button" md-icon-button (click)="table.cancelRemove($event)">
          <md-icon aria-label="Cancel selection of items to delete">clear</md-icon>
        </button>
        <span fxFlex></span>
        <button type="button" md-icon-button (click)="table.remove($event)">
          <md-icon aria-label="Delete selected items">done</md-icon>
        </button>
      </div>
    </md-toolbar>
  `,
  styles: [`
    md-toolbar.o-light-table-button-panel{background-color:#eee;color:rgba(0,0,0,0.87);border-top:1px solid #fff;border-bottom:1px solid #fff;overflow:initial}md-toolbar.o-light-table-button-panel p{font-size:small}md-toolbar.o-light-table-button-panel [md-button].mat-icon-button{color:rgba(0,0,0,0.87)}
  `],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OLightTableComponent, decorators: [{ type: Inject, args: [forwardRef(() => OLightTableComponent), ] }, ]},
];
}


export class OLightTableButtonPanelModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OLightTableButtonPanelComponent],
  imports: [OSharedModule, CommonModule],
  exports: [OLightTableButtonPanelComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
